import { AlertCircle } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface ErrorFallbackProps {
  title?: string
  description?: string
  onRetry?: () => void
  showRetry?: boolean
  fullPage?: boolean
}

export function ErrorFallback({
  title,
  description,
  onRetry,
  showRetry = true,
  fullPage = false,
}: Readonly<ErrorFallbackProps>) {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        "flex min-h-[400px] flex-col items-center justify-center gap-4 p-8",
        fullPage && "min-h-screen"
      )}
    >
      <div className="rounded-full bg-muted p-3">
        <AlertCircle className="size-6 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-medium">{title ?? t("common.somethingWentWrong")}</h2>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        {description ?? t("common.unexpectedError")}
      </p>
      {showRetry && (
        <Button onClick={onRetry ?? (() => globalThis.location.reload())}>
          {t("common.tryAgain")}
        </Button>
      )}
    </div>
  )
}
